import { useEffect } from "react";
import { usePersonalization } from "./useSettings";

const STORAGE_KEY = "adara-theme";

function resolveTheme(preference: string): "light" | "dark" {
  if (preference === "dark") {
    return "dark";
  }
  if (preference === "system") {
    return window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  }
  return "light";
}

function applyTheme(resolved: "light" | "dark") {
  document.documentElement.classList.toggle("dark", resolved === "dark");
  localStorage.setItem(STORAGE_KEY, resolved);

  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) {
    meta.setAttribute("content", resolved === "dark" ? "#0f172a" : "#193B69");
  }
}

/** Syncs the backend theme preference with the DOM .dark class. */
export function useThemeSync() {
  const { data: prefs } = usePersonalization();
  const preference = prefs?.theme ?? "light";

  useEffect(() => {
    const resolved = resolveTheme(preference);
    applyTheme(resolved);

    if (preference !== "system") {
      return;
    }

    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (e: MediaQueryListEvent) => {
      applyTheme(e.matches ? "dark" : "light");
    };
    mq.addEventListener("change", handler);
    return () => {
      mq.removeEventListener("change", handler);
    };
  }, [preference]);
}
